import { createTheme } from '@mui/material/styles'

const theme = createTheme({
    palette: {
        primary: {
            main: '#01C36C',
            dark: '#019953',
            light: '#E4F7EC'
        }
    },
    typography: {
        fontFamily: "'Inter', Helvetica, Arial, sans-serif"
    },
    shape: {
        borderRadius: 8
    },
    // every field wrapper in this app (FieldText/FieldSelect/PickerDate)
    // defaults to size="small" already, but MUI's own "small" is still
    // sized for a general web form, not an admin panel — this is the one
    // place that density gets set app-wide instead of per-page overrides
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: 13
                },
                input: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: 13
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: 11,
                    marginTop: 2,
                    marginLeft: 0
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: 13,
                    minHeight: 32
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    fontSize: 12,
                    padding: '4px 14px'
                }
            }
        }
    }
})

export { theme }
